import { render, staticRenderFns } from "./DialogGeneralInfoDeleteConfirm.vue?vue&type=template&id=2380b1db&"
import script from "./DialogGeneralInfoDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./DialogGeneralInfoDeleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports